var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCameraFilmSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E60C8F"
    },
    d: "M486.651,197.851v162.811c0,4.023-2.114,7.749-5.566,9.806c-1.806,1.074-3.829,1.623-5.863,1.623 c-1.863,0-3.726-0.457-5.417-1.371l-73.897-39.771v34.091c0,6.309-5.12,11.429-11.429,11.429H249.657L311.6,495.291 c2.914,5.589,0.743,12.491-4.846,15.417c-1.691,0.88-3.497,1.291-5.28,1.291c-4.126,0-8.103-2.24-10.137-6.149L230.811,389.76 l-60.526,116.091c-2.046,3.909-6.023,6.149-10.149,6.149c-1.783,0-3.589-0.411-5.269-1.291c-5.6-2.926-7.771-9.829-4.857-15.417 l61.954-118.823H77.131c-6.309,0-11.429-5.12-11.429-11.429v-51.886H36.777c-6.32,0-11.429-5.12-11.429-11.429v-44.937 c0-6.32,5.109-11.429,11.429-11.429h28.926v-51.886c0-6.309,5.12-11.429,11.429-11.429h10.446 c-13.874-13.977-22.469-33.2-22.469-54.4c0-42.594,34.663-77.257,77.257-77.257c23.909,0,45.314,10.926,59.497,28.034 C212.709,33.486,253.246,0,301.463,0C357.954,0,403.92,45.954,403.92,102.457c0,32.091-14.846,60.789-38.023,79.589h18.583 c6.309,0,11.429,5.12,11.429,11.429v34.091l73.897-39.783c3.543-1.909,7.829-1.806,11.28,0.251 C484.537,190.103,486.651,193.829,486.651,197.851z M463.794,341.531V216.983l-67.886,36.537v51.474L463.794,341.531z M373.051,353.611v-41.794v-65.12v-41.794H88.56v51.886v44.937v51.886h142.046c0.011,0,0.034,0,0.046,0h0.297 c0.023,0,0.046-0.011,0.069,0H373.051z M381.063,102.457c0-43.897-35.714-79.6-79.6-79.6s-79.589,35.703-79.589,79.6 c0,43.886,35.703,79.589,79.589,79.589S381.063,146.343,381.063,102.457z M197.166,182.046h39.874 c-9.006-7.303-16.743-16.091-22.846-25.989C210.297,165.851,204.48,174.686,197.166,182.046z M196.766,127.646 c0-29.989-24.4-54.4-54.4-54.4c-29.989,0-54.4,24.411-54.4,54.4c0,30,24.411,54.4,54.4,54.4 C172.366,182.046,196.766,157.646,196.766,127.646z M65.703,290.297v-22.08H48.206v22.08L65.703,290.297L65.703,290.297z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffe0f0"
    },
    points: "463.794,216.983 463.794,341.531 395.909,304.994 395.909,253.52 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffe0f0"
    },
    d: "M373.051,311.817v41.794H231.017c-0.023-0.011-0.046,0-0.069,0h-0.297c-0.011,0-0.034,0-0.046,0 H88.56v-51.886v-44.937v-51.886h284.491v41.794L373.051,311.817L373.051,311.817z M335.966,260.423 c0-6.309-5.12-11.429-11.429-11.429c-6.309,0-11.429,5.12-11.429,11.429c0,6.309,5.12,11.429,11.429,11.429 C330.846,271.851,335.966,266.731,335.966,260.423z M335.966,298.091c0-6.32-5.12-11.429-11.429-11.429 c-6.309,0-11.429,5.109-11.429,11.429c0,6.309,5.12,11.429,11.429,11.429C330.846,309.52,335.966,304.4,335.966,298.091z M275.451,309.52v-60.526c0-6-4.869-10.857-10.857-10.857H140.331c-6,0-10.857,4.857-10.857,10.857v60.526 c0,5.989,4.857,10.857,10.857,10.857h124.263C270.583,320.377,275.451,315.509,275.451,309.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffe5f4"
    },
    d: "M301.463,22.857c43.886,0,79.6,35.703,79.6,79.6c0,43.886-35.714,79.589-79.6,79.589 s-79.589-35.703-79.589-79.589C221.874,58.56,257.577,22.857,301.463,22.857z M351.326,102.457 c0-27.497-22.366-49.863-49.863-49.863c-27.486,0-49.851,22.366-49.851,49.863c0,27.486,22.366,49.851,49.851,49.851 C328.96,152.309,351.326,129.943,351.326,102.457z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E60C8F"
    },
    d: "M301.463,52.594c27.497,0,49.863,22.366,49.863,49.863c0,27.486-22.366,49.851-49.863,49.851 c-27.486,0-49.851-22.366-49.851-49.851C251.611,74.96,273.977,52.594,301.463,52.594z M328.469,102.457 c0-14.891-12.114-27.006-27.006-27.006c-14.88,0-26.994,12.114-26.994,27.006c0,14.88,12.114,26.994,26.994,26.994 C316.354,129.451,328.469,117.337,328.469,102.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E60C8F"
    },
    d: "M324.537,248.994c6.309,0,11.429,5.12,11.429,11.429c0,6.309-5.12,11.429-11.429,11.429 c-6.309,0-11.429-5.12-11.429-11.429C313.109,254.114,318.229,248.994,324.537,248.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E60C8F"
    },
    d: "M324.537,286.663c6.309,0,11.429,5.109,11.429,11.429c0,6.309-5.12,11.429-11.429,11.429 c-6.309,0-11.429-5.12-11.429-11.429C313.109,291.771,318.229,286.663,324.537,286.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E60C8F"
    },
    d: "M275.451,248.994v60.526c0,5.989-4.869,10.857-10.857,10.857H140.331 c-6,0-10.857-4.869-10.857-10.857v-60.526c0-6,4.857-10.857,10.857-10.857h124.263 C270.583,238.137,275.451,242.994,275.451,248.994z M253.737,298.663v-38.811H151.189v38.811H253.737z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 151.189,
    y: 259.851,
    style: {
      fill: "#ffe0f0"
    },
    width: 102.549,
    height: 38.811
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffe5f4"
    },
    d: "M142.366,73.246c30,0,54.4,24.411,54.4,54.4c0,30-24.4,54.4-54.4,54.4c-29.989,0-54.4-24.4-54.4-54.4 C87.966,97.657,112.377,73.246,142.366,73.246z M177.086,127.646c0-19.143-15.577-34.72-34.72-34.72s-34.709,15.577-34.709,34.72 s15.566,34.72,34.709,34.72S177.086,146.789,177.086,127.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E60C8F"
    },
    d: "M142.366,92.926c19.143,0,34.72,15.577,34.72,34.72s-15.577,34.72-34.72,34.72 s-34.709-15.577-34.709-34.72S123.223,92.926,142.366,92.926z M156.514,127.646c0-7.794-6.343-14.149-14.149-14.149 c-7.794,0-14.137,6.354-14.137,14.149c0,7.806,6.343,14.149,14.137,14.149C150.171,141.794,156.514,135.451,156.514,127.646z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.206,
    y: 268.217,
    style: {
      fill: "#ffe0f0"
    },
    width: 17.497,
    height: 22.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraFilmSvgrepoCom);
export default __webpack_public_path__ + "static/media/video-camera-film-svgrepo-com.1fed5bc81767c2b6eab616a9cee65092.svg";
export { ForwardRef as ReactComponent };